import { getModulePluginStore } from "../../../dt-plugins/module-plugins/store";

export const AccountingModulePluginStore = getModulePluginStore('ACCOUNTING_PLUGINS', {
  storeNamespace: 'AccountingStore',
  plugins_section: 'Accounting',
});
